export default "__VITE_ASSET__BOCggS7Q__"